import React from 'react';
import { MapPin, Clock, Phone, Instagram, Mail } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
const TikTokIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-43">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-44" />
  </svg>;
export const Footer = () => {
  return <footer id="ubicacion" className="scroll-mt-40 pt-24 pb-12 px-6 md:px-12 max-w-7xl mx-auto border-t border-white/20" data-id="element-45">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-16" data-id="element-46">
        {/* Left: Location & Contact */}
        <div className="space-y-10" data-id="element-47">
          {/* Map Placeholder */}
          <div className="glass-panel w-full h-64 rounded-3xl flex flex-col items-center justify-center text-brand-charcoal/60 gap-3 border-dashed" data-id="element-48">
            <MapPin size={32} className="opacity-50" data-id="element-49" />
            <p className="font-serif italic text-xl" data-id="element-50">
              Mariara, Carabobo, Venezuela
            </p>
            <p className="font-sans text-xs tracking-widest uppercase" data-id="element-51">
              Consulta dirección exacta por WhatsApp
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-52">
            <div className="space-y-4" data-id="element-53">
              <div className="flex items-start gap-3 text-brand-charcoal/80" data-id="element-54">
                <Clock size={20} className="mt-0.5 shrink-0" data-id="element-55" />
                <div data-id="element-56">
                  <p className="font-medium mb-1" data-id="element-57">Horario</p>
                  <p className="font-light text-sm" data-id="element-58">Lun - Sáb: 10:00 - 19:30</p>
                  <p className="font-light text-sm" data-id="element-59">Domingo: Cerrado</p>
                </div>
              </div>
            </div>

            <div className="space-y-4" data-id="element-60">
              <div className="flex items-start gap-3 text-brand-charcoal/80" data-id="element-61">
                <Phone size={20} className="mt-0.5 shrink-0" data-id="element-62" />
                <div data-id="element-63">
                  <p className="font-medium mb-1" data-id="element-64">Contacto</p>
                  <a href="https://wa.me/584244582867" target="_blank" rel="noreferrer" className="font-light text-sm hover:underline inline-flex items-center gap-2 text-brand-charcoal/80" data-id="element-65">
                    <WhatsAppIcon className="w-4 h-4 text-brand-charcoal shrink-0" data-id="element-66" />
                    +58 424 458 2867
                  </a>
                  <a href="mailto:pinzcolorsve@gmail.com" className="font-light text-sm hover:underline block mt-1" data-id="element-67">
                    pinzcolorsve@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-68">
            <a href="https://wa.me/584244582867" target="_blank" rel="noreferrer" aria-label="WhatsApp" className="w-12 h-12 rounded-full glass-button flex items-center justify-center text-brand-charcoal hover:scale-110 transition-transform" data-id="element-69">
              <WhatsAppIcon className="w-6 h-6" data-id="element-70" />
            </a>
            <a href="https://www.instagram.com/pinzcolors.ve?igsh=MXdmczJkZW1sZGdpeg==" target="_blank" rel="noreferrer" className="w-12 h-12 rounded-full glass-button flex items-center justify-center text-brand-charcoal hover:scale-110" data-id="element-71">
              <Instagram size={20} data-id="element-72" />
            </a>
            <a href="https://www.tiktok.com/@pinzcolors.ve?_t=8pm1iZRAzZN&_r=1" target="_blank" rel="noreferrer" className="w-12 h-12 rounded-full glass-button flex items-center justify-center text-brand-charcoal hover:scale-110" data-id="element-73">
              <TikTokIcon className="w-5 h-5" data-id="element-74" />
            </a>
            <a href="mailto:pinzcolorsve@gmail.com" className="w-12 h-12 rounded-full glass-button flex items-center justify-center text-brand-charcoal hover:scale-110" data-id="element-75">
              <Mail size={20} data-id="element-76" />
            </a>
          </div>
        </div>

        {/* Right: Branding */}
        <div className="flex flex-col justify-between lg:items-end text-left lg:text-right" data-id="element-77">
          <div data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/ngcXTe9zUot3WuzoRAWaGH/Logo_sin_fondo_letra_negra.png" alt="PinzColors Logo" className="h-32 md:h-44 object-contain mb-8 lg:ml-auto" data-id="element-79" />
            <p className="font-serif italic text-2xl text-brand-charcoal mb-2" data-id="element-80">
              El arte de cuidar tus manos.
            </p>
            <p className="font-sans font-light text-brand-charcoal/60 max-w-sm lg:ml-auto" data-id="element-81">
              Estudio de uñas especializado en técnicas modernas, salud natural
              y diseños exclusivos.
            </p>
          </div>

          <div className="mt-16 lg:mt-0" data-id="element-82">
            <p className="font-sans text-xs tracking-widest uppercase text-brand-charcoal/40" data-id="element-83">
              © 2026 PinzColors by Laura Pinzón.
              <br className="md:hidden" data-id="element-84" /> Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};